module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.form,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据限制",
      "prop": "write_num"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.curInput.form.write_num),
      expression: "curInput.form.write_num",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.curInput.form.write_num)
    },
    on: {
      "input": function($event) {
        _vm.curInput.form.write_num = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c2857b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/subformConfig.vue
// module id = 1937
// module chunks = 2